import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Autoplay]);
import 'swiper/swiper-bundle.min.css';

// import 'swiper/swiper.min.css';
// import 'swiper/modules/navigation/navigation.min.css';
// import 'swiper/modules/pagination/pagination.min.css';

class SwiperSlider {
    constructor(elem) {
        this.elem = elem;
        this.slidesPerView = this.elem.dataset.slides;
        this.autoplay = this.elem.dataset.autoslide;
        this.pagination = this.elem.dataset.pagination;
        this.sliderID = this.elem.id;
    }

    init() {
        if (!this.slidesPerView || this.slidesPerView === '0') {
            this.slidesPerView = 4;
        }

        let setAutoplay = false;
        let setPagination = false;

        if (this.autoplay === '1') {
            setAutoplay = {
                delay: 7000,
                disableOnInteraction: false,
            };
        }

        if (this.pagination === '1') {
            setPagination = {
                el: `.swiper-pagination--outer-${this.sliderID}`,
                clickable: true,
            };
        }

        const swiper = new Swiper(this.elem, {
            spaceBetween: 30,
            loop: true,
            slidesPerView: 1,
            autoplay: setAutoplay,
            modules: [Navigation, Pagination],
            pagination: {
                el: `.swiper-pagination--outer-${this.sliderID}`,
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: this.slidesPerView,
                    pagination: setPagination,
                    navigation: {
                        nextEl: `.swiper-button-container-${this.sliderID} .swiper-button-next--outer`,
                        prevEl: `.swiper-button-container-${this.sliderID} .swiper-button-prev--outer`,
                    },
                },
            },
        });
    }
}

export default SwiperSlider;
